import type { PaginatedResponse, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { brigadeEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	Brigade,
	CreateBrigadeRequest,
	ListBrigadesParams,
	UpdateBrigadeRequest,
} from "../types";

export const brigadeService = {
	async list(params?: ListBrigadesParams): Promise<PaginatedResponse<Brigade>> {
		const response = await apiClient.get<PaginatedResponse<Brigade>>(brigadeEndpoints.list, {
			params,
		});
		return response.data;
	},

	async create(data: CreateBrigadeRequest): Promise<Brigade> {
		const response = await apiClient.post<SuccessResponse<Brigade>>(brigadeEndpoints.create, data);
		return response.data.data;
	},

	async getById(id: string): Promise<Brigade> {
		const url = replaceParams(brigadeEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<Brigade>>(url);
		return response.data.data;
	},

	async update(id: string, data: UpdateBrigadeRequest): Promise<Brigade> {
		const url = replaceParams(brigadeEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<Brigade>>(url, data);
		return response.data.data;
	},
};
